<template>
  <div class="page">
    <Map v-if="showMap" :windowHeight="windowHeight" v-on:success="success" />
    <div class="tit" style="margin-top:0">
      <span>店铺信息</span>
    </div>
    <div class="box">
      <van-cell-group>
        <van-field v-model="params.storeName" label="店铺名称" placeholder="请输入店铺名称" />
        <van-field v-model="params.storeTradeArea" label="店铺地址" placeholder="点击选择" @click="showMap = true" readonly/>
        <van-field v-model="params.fullAddress" label="门牌号" placeholder="请输入门牌号" />
        <van-field
          readonly
          clickable
          label="经营类目"
          :value="storeProductName"
          placeholder="点击选择您的经营类目"
          @click="showPicker = true"
        >
          <template #button>
            <van-icon name="arrow" />
          </template>
        </van-field>
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            value-key="name"
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
      </van-cell-group>
    </div>
    <div class="tit">
      <span>联系方式（必填）</span>
    </div>
    <div class="box">
      <van-cell-group>
        <van-field label-width="0" v-model="params.storeContactPhone" placeholder="请输入手机号码" />
      </van-cell-group>
    </div>
    <div class="tit">
      <span>店铺图片（必填）</span>
    </div>
    <div class="box">
      <UploadImg v-on:successImg="successImg" :pic="params.storeIcon" />
    </div>
    <div class="foot-btn" @click="onSubmit">
      提交
    </div>
  </div>   
</template>

<script>
import Map from '../../components/map/map'
import UploadImg from '../../components/upload/uploadImg'
import WxValidate from '@/util/WxValidate'

export default {
  data () {
    return {
      windowHeight: document.documentElement.clientHeight,
      params: {
        storeName: '',
        fullAddress: '',
        storeContactPhone: '',
        lat: '',
        lng: '',
        productType: '',
        storeTradeArea: '',
        storeIcon: ''
      },
      id: '20200902',
      search: '',
      showPicker: false,
      columns: [],
      fileList: [],
      showMap: false,
      poiaddress: '',
      storeProductName: ''
    }
  },
  components: {
    Map,
    UploadImg
  },
  created () {
    this.withChildren()
    this.initValidate()
  },
  methods: {
    successImg(e){
      this.params.storeIcon = e
    },
    //表单验证
    initValidate() {
      let rules = {
        storeName: {
          required: true,
          maxlength: 20
        },
        storeTradeArea: {
          required:true
        },
        fullAddress: {
          required:true
        },
        productType: {
          array:true
        },
        storeContactPhone:{
          required:true,
          tel: true
        },
        storeIcon:{
          required:true
        }
      }
      let message = {
        storeName: {
          required: '请输入店铺名称',
          maxlength: '店铺名称不能超过20个字'
        },
        storeTradeArea: {
          required: '请选择地址'
        },
        fullAddress: {
          required: '请输入门牌号'
        },
        productType: {
          array: '请选择经营类目'
        },
        storeContactPhone:{
          required: '请输入联系电话',
          tel: '联系电话格式'
        },
        storeIcon:{
          required: '请上传店铺图片'
        }
      }
      //实例化当前的验证规则和提示消息
      this.WxValidate = new WxValidate(rules, message);
    },
    async withChildren () {
      const result = await this.$api.store.withChildren()
      this.columns = result.data
    },
    success (e) {
      this.showMap = false
      this.params.lat = e.latlng.lat
      this.params.lng = e.latlng.lng
      this.params.storeTradeArea = e.poiaddress
    },
    onConfirm (e) {
      this.showPicker = false
      this.params.productType = [e.id]
      this.storeProductName = e.name
    },
    afterRead (file) {
      file.status = 'uploading'
      file.message = '上传中...'
      setTimeout(() => {
        file.status = 'failed'
        file.message = '上传失败'
      }, 1000)
    },
    onSubmit () {
      if (!this.WxValidate.checkForm(this.params)) {
        const error = this.WxValidate.errorList[0]
        this.$toast(error.msg)
        return false
      }
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      this.$api.activity.addVoteActivityStoreForOperation(this.params).then(res => {
        if (res.status == 0) {
          this.params = {}
          this.storeProductName = ''
          this.$toast.clear()
          this.$toast('录入成功')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>

  @import "~@/assets/css/var.less";

  .page{
    box-sizing: border-box;
    padding-top: 20px;
  }
  .tit{
    box-sizing: border-box;
    font-size: 12px;
    color: #9A9A9A;
    display: flex;
    padding: 0 31px;
    margin: 20px 0 10px;
  }
  .box{
    width: 92%;
    background: #FFFFFF;
    border-radius: 10px;
    margin: 0 auto;
  }
  .foot-btn{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 49px;
    background: #FF9A32;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    color: #FFFFFF;
    position: fixed;
  }

</style>
